import React from "react";
import $ from "$";
import { Icon } from "antd";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { getFd } from "../../wea-tools/callApi";
import WeaNewScroll from "../../wea-new-scroll";
import WeaAlertPage from "../../wea-alert-page";
import Operation from "../../wea-transfer/operation";
import HrmList from "../components/WeaHrmList";
import TableSingle from "../components/WeaTableSingle";
import SelectedList from "../components/WeaSelectedRight";
import WeaBrowserTree from "../components/WeaBrowserTree";
import { contentTypeMap } from "./propType";
import { getLabel } from "../../wea-locale-provider/util";

// 获取人力资源浏览框显示内容
export function getHrmMainContent() {
  const {
    isSingle,
    icon,
    iconBgcolor,
    topPrefix,
    dataParams,
    is_012app,
    recentUrl,
    contentHeight,
    checkGroup,
    defaultCurrentUser
  } = this.props;
  const {
    activeKey,
    inputId,
    inputTop,
    inputBottom,
    dataOfListWithoutKeyButPg,
    idCache,
    nameCache,
    treeDatas,
    groupTreeDatas,
    defaultExpandedKeys,
    selectedData,
    leftCheckedData,
    leftTreeCheckedKeys,
    leftTreeCheckedData,
    leftGroupCheckedKeys,
    leftGroupCheckedData,
    isAccount,
    hasRight,
    checkStrictly,
    contentType
  } = this.state;
  if (!this.isCrm()) return null;
  const datas =
    (dataOfListWithoutKeyButPg && dataOfListWithoutKeyButPg.datas) || [];
  let content;
  if (contentType == 6 || contentType == 7) {
    let browserTreeProps = {
      icon,
      iconBgcolor,
      dataParams,
      recentUrl,
      isAccount,
      topPrefix,
      checkable: false,
      isMult: !isSingle,
      ztreeMode: false,
      isHrmTree: true,
      inputTop,
      inputBottom,
      // virtualtype: companyId,
      // treeKey: "hr"
      defaultCurrentUser,
      defaultExpandedKeys,
      ...this.getAsyncParams()
    };
    if (isSingle) {
      browserTreeProps = {
        ...browserTreeProps,
        dataParams,
        checkable: false,
        hasRadio: true,
        radioCheckedData: { id: idCache, name: nameCache },
        setRadioData: (id, name, data) => this.onHrmTableChange([id], [data]),
        setData: this.onHrmTableChange
      };
    } else {
      browserTreeProps = {
        ...browserTreeProps,
        checkStrictly,
        className: "rsc-wrapper",
        checkGroup, // 可以选择部门，分部
        onDoubleClick: this.onleftTreeDoubleClick,
        // onDoubleClick: this.onleftDoubleClick,
        filterData: this.getFilterData(selectedData)
      };
    }
    if (contentType == 6) {
      browserTreeProps = {
        ...browserTreeProps,
        treeData: treeDatas
      };
      if (!isSingle) {
        browserTreeProps = {
          ...browserTreeProps,
          checkedCb: this.onLeftTreeCheck,
          checkedKeys: leftTreeCheckedKeys
          // checkedDatas: leftTreeCheckedData
        };
      }
    } else if (contentType == 7) {
      browserTreeProps = {
        ...browserTreeProps,
        hasRight,
        treeData: groupTreeDatas,
        getGrouptree: () => this.onSearch({}, activeKey)
      };
      if (!isSingle) {
        browserTreeProps = {
          ...browserTreeProps,
          checkedCb: this.onLeftGroupCheck,
          checkedKeys: leftGroupCheckedKeys
          // checkedDatas: leftGroupCheckedData
        };
      }
    }
    content = isEmpty(browserTreeProps.treeData) ? (
      this.renderEmpty()
    ) : (
      <div className="wea-tree-hr">
        <WeaBrowserTree {...browserTreeProps} />
      </div>
    );
  } else {
    let hrmListProps = {
      is_012app,
      isSingle,
      inputTop,
      inputBottom,
      datas
    };
    if (isSingle) {
      hrmListProps = {
        ...hrmListProps,
        onClick: this.onHrmTableChange
      };
    } else {
      const leftCheckedKeys = leftCheckedData.map(item => item[inputId]);
      hrmListProps = {
        ...hrmListProps,
        onDoubleClick: this.onleftDoubleClick,
        onClick: this.onleftClick,
        selectedKeys: leftCheckedKeys,
        filterData: selectedData
      };
    }
    content = <HrmList {...hrmListProps} />;
  }
  let showDropMenu = ["2", "3", "4"].indexOf(activeKey) !== -1;
  const hasPagination = ["1", "2", "3", ""].indexOf(activeKey) !== -1;
  const showButtons = {
    showAccount: ["2", "3", "4", "5", ""].indexOf(activeKey) !== -1,
    showAllbranch: activeKey == "3",
    showCheckStrictly: !isSingle && ["4", "5"].indexOf(activeKey) !== -1
  };
  // if (hideVirtualOrg) showDropMenu = false;
  const cHeight = this.getContentHeight({
    showDropMenu,
    showAdvanceSearch: !isSingle,
    showPagination: hasPagination
  });
  let btnsOffsetTop = 15;
  if (showDropMenu) {
    btnsOffsetTop += 37;
  }
  if (!isSingle) {
    btnsOffsetTop += 35;
  }
  return [
    !isSingle && this.getActionBarInTrans(),
    showDropMenu && this.getDropMenuInTrans(),
    <WeaNewScroll height={cHeight} ref={el => (this.weaSrcoll = el)}>
      {content}
    </WeaNewScroll>,
    this.getTreeButtonInTrans(showButtons, { top: btnsOffsetTop }),
    hasPagination && this.getPaginationInTrans()
  ];
}

// 穿梭框的左右选操作
export function moveTo(direction) {
  const {
    inputId,
    selectedData,
    leftCheckedData,
    leftTreeCheckedData,
    leftGroupCheckedData,
    rightCheckedData,
    dataOfListWithkey,
    dataOfListWithoutKeyAndPg,
    dataOfListWithoutKeyButPg
  } = this.state;
  let newState = {};
  if (/right$/i.test(direction)) {
    if (leftTreeCheckedData.length > 0 || leftGroupCheckedData.length > 0) {
      this.setState({ loading: true });
      this.callSelectedReq(this.getExtraParams()).then(res => {
        let newState = {};
        const datas = leftCheckedData.concat(
          this.isCrm() ? this.formatData(res.datas || []) : res.datas
        );
        const rds = selectedData.concat(datas);
        newState = {
          ...newState,
          loading: false,
          selectedData: uniqBy(rds, this.isCrm() ? "nodeid" : inputId || "id"),
          leftTreeCheckedData: [],
          leftTreeCheckedKeys: [],
          leftGroupCheckedData: [],
          leftGroupCheckedKeys: []
        };
        this.setState(newState);
      });
    } else {
      const addDatas =
        direction === "right"
          ? leftCheckedData
          : [
              ...dataOfListWithkey,
              ...((dataOfListWithoutKeyAndPg &&
                dataOfListWithoutKeyAndPg.datas) ||
                []),
              ...((dataOfListWithoutKeyButPg &&
                dataOfListWithoutKeyButPg.datas) ||
                [])
            ];
      newState.leftCheckedData = [];
      newState.selectedData = uniq(selectedData.concat(addDatas));
    }
  } else if (/left$/i.test(direction)) {
    newState.rightCheckedData = [];
    newState.selectedData =
      direction === "left"
        ? selectedData.filter(
            d => !rightCheckedData.some(r => r[inputId] === d[inputId])
          )
        : [];
  }
  this.setState(newState);
}

export function renderEmpty() {
  let param = {
    icon: <Icon type="frown" />,
    iconSize: 12,
    minHeight: 432
  };
  return (
    <WeaAlertPage {...param}>
      <span style={{ paddingLeft: 15, color: "#999" }}>
        {getLabel("83553", "暂无数据")}
      </span>
    </WeaAlertPage>
  );
}

// 获取浏览框显示内容
export function getModalMainContent() {
  const {
    isSingle,
    hasRadio,
    dataURL,
    type,
    hideVirtualOrg,
    icon,
    isImgIcon,
    topPrefix,
    checkStrictly,
    asynLoadAll,
    dataParams,
    defaultExpandedLevel,
    showCheck = true,
    showCheckBtn = true,
    isMultCheckbox
  } = this.props;
  const {
    contentType,
    inputTop,
    inputBottom,
    dataKey,
    dataOfListWithoutKeyAndPg,
    dataOfListWithoutKeyButPg,
    pageSize,
    idCache,
    nameCache,
    treeDatas,
    selectedData,
    showCheckedDatas,
    defaultExpandedKeys,
    loadAllTreeData
  } = this.state;
  if (isSingle || isMultCheckbox) {
    if (this.isCrm()) return this.getHrmMainContent();
    let content;
    let showDropMenu = contentType == 3 && (type == "4" || type == "164");
    if (hideVirtualOrg) showDropMenu = false;
    let cHeight = this.getContentHeight({
      showDropMenu
    });
    if (contentType == 3) {
      content = isEmpty(treeDatas) ? (
        this.renderEmpty()
      ) : (
        <WeaBrowserTree
          hasRadio={true}
          ztreeMode={false}
          isImgIcon={isImgIcon}
          type={type}
          onDoubleClick={this.onleftTreeDoubleClick}
          checkable={true}
          topPrefix={topPrefix}
          {...this.getAsyncParams()}
          setRadioData={this.onTreeClick}
          inputId={inputId}
          inputName={inputName}
          inputTop={inputTop}
          inputBottom={inputBottom}
          radioCheckedData={{ id: idCache, name: nameCache }}
          icon={icon}
          treeData={treeDatas}
          defaultExpandedKeys={defaultExpandedKeys}
          checkStrictly={checkStrictly}
          isLoadAll={loadAllTreeData}
          asynLoadAll={asynLoadAll}
          defaultExpandedLevel={defaultExpandedLevel}
        />
      );
    } else {
      let keyProps = {};
      if (contentType == 1) {
        keyProps = { dataKey, hasPagination: true, url: `${dataURL}${type}` };
      }
      if (contentType == 2) {
        keyProps = {
          noPgTableData: dataOfListWithoutKeyAndPg,
          hasPagination: false,
          url: `${dataURL}${type}`
        };
      }
      if (contentType == 4) {
        keyProps = {
          hasPgTableData: dataOfListWithoutKeyButPg,
          hasPagination: true,
          url: `${dataURL}${type}?${getFd(dataParams)}`
        };
      }
      let tableProps = {
        ...keyProps,
        hasRadio,
        contentType: contentTypeMap[contentType],
        setLoading: v => this.setState({ loading: v }),
        ...this.props,
        pageSize
      };
      if (isMultCheckbox) {
        tableProps = {
          ...tableProps,
          checkedDatas: selectedData,
          keepSelectedRowKeys: true,
          getSelection: this.onMultTableCheck,
          showCheck,
          showCheckBtn,
          showCheckedDatas,
          showCheckedDatasChange: bool =>
            this.setState({ showCheckedDatas: bool })
        };
      } else {
        tableProps = {
          ...tableProps,
          getSelection: this.onTableCheck,
          setData: this.onTableChange
        };
      }
      content = <TableSingle {...tableProps} />;
    }
    if (contentType == 1 || contentType == 2 || contentType == 4) {
    } else {
      content = (
        <WeaNewScroll height={cHeight} ref={el => (this.weaSrcoll = el)}>
          {content}
        </WeaNewScroll>
      );
    }
    return [showDropMenu && this.getDropMenuInTrans(), content];
  }
  const {
    inputId,
    inputName,
    leftCheckedData,
    leftTreeCheckedData,
    leftGroupCheckedData,
    rightCheckedData,
    dataOfListWithkey
  } = this.state;
  const isTree = contentType == 3 || contentType == 6 || contentType === 7;
  const clsLeft = classNames("wea-hr-muti-input-left", {
    displayTree: isTree
  });
  const listDatas = [
    ...dataOfListWithkey,
    ...((dataOfListWithoutKeyAndPg && dataOfListWithoutKeyAndPg.datas) || []),
    ...((dataOfListWithoutKeyButPg && dataOfListWithoutKeyButPg.datas) || [])
  ];
  const oprationProps = {
    leftActive: rightCheckedData.length > 0,
    rightActive:
      leftCheckedData.length > 0 ||
      leftTreeCheckedData.length > 0 ||
      leftGroupCheckedData.length > 0,
    leftAllActive:
      !isTree &&
      listDatas.length > 0 &&
      listDatas.filter(d => !selectedData.some(s => s[inputId] === d[inputId]))
        .length > 0,
    rightAllActive: selectedData.length > 0
  };
  const rightCheckedKeys = rightCheckedData
    .filter(item => !!item)
    .map(item => item[this.isCrm() ? "nodeid" : inputId]);
  return (
    <div style={{ padding: 10 }} ref="weaModalContent">
      <div className={clsLeft}>{this.getModalMainContentLeft()}</div>
      <div className="wea-transfer-opration">
        <Operation
          {...oprationProps}
          moveToLeft={() => this.moveTo("left")}
          moveAllToLeft={() => this.moveTo("allToLeft")}
          moveToRight={() => this.moveTo("right")}
          moveAllToRight={() => this.moveTo("allToRight")}
        />
      </div>
      <div className="wea-hr-muti-input-right">
        <SelectedList
          {...this.props}
          contentType={contentType}
          inputId={inputId}
          inputName={inputName}
          inputTop={inputTop}
          inputBottom={inputBottom}
          data={selectedData}
          checkedCb={this.onSelectedListCheck}
          onDoubleClick={this.onSelectedListDoubleClick}
          checkedKeys={rightCheckedKeys}
          height={this.getContentHeight({ showAdvanceSearch: true })}
          onDrag={data => this.setState({ selectedData: data })}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getModalContent.js